import styled from 'styled-components';
import ds, { media } from 'designsystem';
import { bigImageWidth, mediumImageWidth, smallImageWidth } from 'common/consts/person-image';

const TextColumn = styled.div`
  display: block;
  flex-direction: column;
  vertical-align:top;
  width: 100%;
  margin-top: 20px;

  ${media.mobile`
    display: inline-block;
    width: calc(100% - ${smallImageWidth} - ${ds.get('metrics.s')});
    margin-top: 0;
  `};
    
  ${media.tablet`
    width: calc(100% - ${mediumImageWidth} - ${ds.get('metrics.s')});
  `};
  
  ${media.desktop`
    width: calc(100% - ${bigImageWidth} - ${ds.get('metrics.l')});
  `}
`;

export default TextColumn;



// WEBPACK FOOTER //
// ./src/kentico-blocks/CallUs/ContactPerson/TextColumn.jsx